<template>
  <div>
    <div class="card card-info">
      <div class="card-header">
        <div class="card-title">
          <h5>New</h5>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <label>Employee </label>
            <select class="form-control" v-model="obj.EmployeeID" v-on:change="employeeChange()">
              <option>--Select Employee--</option>
              <option v-for="item in Employees" :value="item.EmployeeRegistrationID">{{item.Name}}</option>
            </select>
          </div>

          <div class="col-md-6">
            <label>Appointment </label>
            <select class="form-control" v-model="obj.EmployeeAppointmentID" v-on:change="appointmentChange()" required>
              <option>--Select Appointment--</option>
              <option v-for="item in Appointment" :value="item.EmployeeAppointmentID">{{item.Name}}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" style="margin-top:12px">
            <div class="table-responsive">
              <h5>Job Authority</h5>
              <table class="table table-bordered table-striped table-sm">
                <thead class="bg-info">
                  <tr>
                    <th>Sr.No. </th>
                    <th>Description</th>
                    <th style="width: 10px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in JA">
                    <td>{{ind+1}}</td>
                    <td>{{item.Description}}</td>
                    <td style="white-space: nowrap">
                      <button class="btn btn-sm btn-info" v-on:click="editJA(ind)"><i class="fas fa-edit"></i></button>
                      <!--<button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteKin" v-on:click="KinIndex = ind;"><i class="fas fa-trash"></i></button>-->
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3">
                      <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="addnewJA()">Add New</button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="col-md-12" style="margin-top:12px">
            <div class="table-responsive">
              <h5>Job Responsibility</h5>
              <table class="table table-bordered table-striped table-sm">
                <thead class="bg-info">
                  <tr>
                    <th>Sr.No. </th>
                    <th>Description</th>
                    <th style="width: 10px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in JR">
                    <td>{{ind+1}}</td>
                    <td>{{item.Description}}</td>
                    <td style="white-space: nowrap">
                      <button class="btn btn-sm btn-info" v-on:click="editJR(ind)"><i class="fas fa-edit"></i></button>
                      <!--<button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteKin" v-on:click="KinIndex = ind;"><i class="fas fa-trash"></i></button>-->
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3">
                      <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="addnewJR()">Add New</button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalJA">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Job Authority</h4>
          </div>
          <form id="contact">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Description</label>
                    <input class="form-control form-control-sm" v-model="JobAuthority.Description" required />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              <button type="button" v-on:click="saveJA()" class="btn btn-success">Save changes</button>
            </div>
          </form>

        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div class="modal fade" id="modalJR">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Job Responsibility</h4>
          </div>
          <form id="contact">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Description</label>
                    <input class="form-control form-control-sm" v-model="JobResponsibility.Description" required />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              <button type="button" v-on:click="saveJR()" class="btn btn-success">Save changes</button>
            </div>
          </form>

        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
  $(document).ready(function () {
    $('[data-mask]').inputmask()
  });

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
    },
    data() {
      return {
        obj: {
          EmployeeID: '',
          EmployeeAppointmentID: '',
        },
        JobAuthority: {
          Description: '',
        },
        JobResponsibility: {
          Description: '',
        },
        Employees: [],
        Appointment: [],
        Templates: [],
        JA: [],
        JR: [],
        Details: [],
        showtable: 'hide',
        totalallowence: 0,
        totaldeductable: 0,
        showgrid: 'show',
      }
    },

    created: function () {
      this.pageload();
    },

    methods: {
      addnew() {
        this.showgrid = 'hide';
      },

      pageload() {
        var vm = this;
        axios.post('/api/EmployeesApi/pageloadEmployeeJD')
          .then(function (res) {
            if (res.data.status)
              vm.Employees = res.data.lst;
          })
      },

      addnewJR() {
        $('#modalJR').modal('show');
      },

      addnewJA() {
        $('#modalJA').modal('show');
      },

      saveJA() {
        var vm = this;
        axios.post('/api/EmployeesApi/SaveJA', {
          obj: vm.JobAuthority,
          EmployeeAppointmentID: vm.obj.EmployeeAppointmentID,
          EmployeeID: vm.obj.EmployeeID,
        })
          .then(function (res) {
            if (res.data.status) {
              toastr.success(res.data.msg);
              $('#modalJA').modal('hide');
              vm.appointmentChange();
            }
            else {
              toastr.success(res.data.msg);
            }
          })
      },

      saveJR() {
        var vm = this;
        axios.post('/api/EmployeesApi/SaveJR', {
          obj: vm.JobResponsibility,
          EmployeeAppointmentID: vm.obj.EmployeeAppointmentID,
          EmployeeID: vm.obj.EmployeeID,
        })
          .then(function (res) {
            if (res.data.status) {
              toastr.success(res.data.msg);
              $('#modalJR').modal('hide');
              vm.appointmentChange();
            }
            else {
              toastr.success(res.data.msg);
            }
          })
      },

      employeeChange() {
        var vm = this;
        axios.post('/api/EmployeesApi/employeeChangeJD?ID=' + vm.obj.EmployeeID)
          .then(function (res) {
            if (res.data.status)
              vm.Appointment = res.data.lst;
          })
      },

      appointmentChange() {
        var vm = this;
        axios.post('/api/EmployeesApi/appointmentChange?AppointmentID=' + vm.obj.EmployeeAppointmentID + '&EmpID=' + vm.obj.EmployeeID)
          .then(function (res) {
            vm.JA = res.data.JA;
            vm.JR = res.data.JR;
          })
      },

      editJA(ind) {
        this.JobAuthority = this.JA[ind];
        $('#modalJA').modal('show');
      },

      editJR(ind) {
        this.JobResponsibility = this.JR[ind];
        $('#modalJR').modal('show');
      },

      cancel() {
        window.location.reload();
      },
    }
  })
</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>



// WEBPACK FOOTER //
// src/components/hr/employeejobdescription.vue